// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".clickable-root-sDL {\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "clickable-root-sDL cursor-pointer inline-flex items-center justify-center leading-none pointer-events-auto text-center"
};
export default ___CSS_LOADER_EXPORT___;
